module.exports = __webpack_public_path__ + "static/media/Rachit_Mehrotra_20210127_Prudential_Asia.3e378e32.jpg";